import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  ViewEncapsulation
} from '@angular/core';

import { TiimeButtonModule } from '../button';
import { TiimeIconModule } from '../icon';
import { TiimeTooltipModule } from '../tooltip';

@Component({
  selector: 'tiime-chip-toggle-action',
  standalone: true,
  imports: [TiimeIconModule, TiimeButtonModule, TiimeTooltipModule],
  templateUrl: './chip-toggle-action.component.html',
  styleUrl: './chip-toggle-action.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tiime-chip-toggle-action'
  }
})
export class ChipToggleActionComponent {
  readonly toggled: InputSignal<boolean> = input.required<boolean>();
  readonly toggledTooltipMessage: InputSignal<string> = input<string>('Inclus');
  readonly untoggledTooltipMessage: InputSignal<string> = input<string>('Exclu');

  readonly toggle: OutputEmitterRef<void> = output<void>();

  emitToggle(): void {
    this.toggle.emit();
  }
}
